import { useRouter } from "next/router";
import { Trans, useTranslation } from "react-i18next";
import { Modal } from "../../../../common/components";
import { COMPANY_ROUTES } from "../../../../common/constants";
import { useSetUpSpacesStore } from "../../store";

interface LocationSetupProps {
    companyId?: string;
}

const LocationSetup = (props: LocationSetupProps) => {
    const { companyId } = props;

    const { t } = useTranslation("setUpSpaces");

    const router = useRouter();

    const { reset } = useSetUpSpacesStore();

    const handleClose = () => {
        reset();
    };

    const handleRedirect = () => {
        // Reload page if user is currently on the redirect page
        if (
            router.pathname === COMPANY_ROUTES.ENERGY.GENERAL &&
            companyId === router.query.companyId
        ) {
            handleClose();
            router.reload();
        } else {
            router
                .push({
                    pathname: COMPANY_ROUTES.ENERGY.GENERAL,
                    query: { companyId },
                })
                .then(() => {
                    handleClose();
                });
        }
    };

    return (
        <Modal
            isOpen
            title={t("setUpSpaces:locationSetup.title")}
            className="max-w-full sm:max-w-5/6 md:max-w-2/3 lg:max-w-1/2"
            hasCancelButton
            hasOkButton
            cancelText={t("setUpSpaces:locationSetup.skipForNow")}
            okText={t("setUpSpaces:locationSetup.goToEnergySettings")}
            onClickClose={handleClose}
            onClickCancel={handleClose}
            onClickOk={handleRedirect}
        >
            <div className="flex flex-col gap-4">
                <div>
                    <Trans
                        i18nKey="setUpSpaces:locationSetup.description"
                        components={{
                            link1: (
                                <span
                                    className="font-medium text-info-default hover:underline cursor-pointer"
                                    onClick={handleRedirect}
                                />
                            ),
                        }}
                    />
                </div>
                <div className="col-span-full flex items-center gap-2 mt-4">
                    <i className="pi pi-info-circle" />
                    <span className="text-wrap">
                        {t("setUpSpaces:locationSetup.info")}
                    </span>
                </div>
            </div>
        </Modal>
    );
};

export default LocationSetup;
